import { useParams } from 'react-router-dom';

import CustomLoader from 'components/shared/CustomLoader/CustomLoader';
import CompanyDetail from './CompanyDetail';
import Header from './Header';
import { useBusinessDetails } from './useBusinessDetails';

const ZoomInfoSelected = () => {
  const { id } = useParams();
  const { data, loading } = useBusinessDetails(id ?? '');

  if (loading || !data) return <CustomLoader open />;

  return (
    <>
      <Header data={data.item} isTargeted={data.isTargeted} />
      <CompanyDetail data={data.item} />
    </>
  );
};

export default ZoomInfoSelected;
